// extracted by mini-css-extract-plugin
module.exports = {"TabList":"Tab_TabList__2K1sG","TabListItem":"Tab_TabListItem__1R2PJ","TabListActive":"Tab_TabListActive__3Q1OP"};